// extracted by mini-css-extract-plugin
export var wrapper = "ThirdQuestion-module--wrapper--77xM9";
export var ChekboxContainer = "ThirdQuestion-module--ChekboxContainer--W8kiy";
export var content = "ThirdQuestion-module--content--K+btq";
export var headline = "ThirdQuestion-module--headline--8TQZP";
export var chekboxAllStyle = "ThirdQuestion-module--chekboxAllStyle--GNKcQ";
export var chekbox1 = "ThirdQuestion-module--chekbox1--3ww53";
export var chekbox2 = "ThirdQuestion-module--chekbox2--6-Dem";
export var icon = "ThirdQuestion-module--icon--M8xVU";
export var subtitle = "ThirdQuestion-module--subtitle--OVb1B";